export const VIDEO_ROOT = 'video-player';
export const REACT_PLAYER_FILE = 'react-player-file';

export const INSERT_YOUTUBE_BUTTON = 'insert-youtube-button';
export const INSERT_VIDEO_BUTTON = 'insert-video-button';

export const INSERT_VIDEO_MODAL = 'insert-video-modal';
export const INSERT_VIDEO_MODAL_SOURCE_TOGGLE = 'insert-video-modal-source-toggle';
export const EMBED_TAB_URL_INPUT = 'insert-video-modal-url-input';
export const EMBED_TAB_SUBMIT_BUTTON = 'insert-video-modal-action-button-save';
export const UPLOAD_TAB_UPLOAD_BUTTON = 'insert-video-modal-custom-video-button';

export const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = 'settings-download-toggle';
export const SETTINGS_SPOILER_TOGGLE = 'settings-spoiler-toggle';
